import { useEffect, useState } from 'react';
import api from '../services/api';

// "Play in browser" (WebGPU build) is in testing. Global admins decide whether the navbar shows it;
// the public signup config carries that flag so every visitor reads the same value.
let cachedNavVisible = false;
let hasFetched = false;
let inFlightRequest = null;
const subscribers = new Set();

const notifySubscribers = () => {
  subscribers.forEach((listener) => {
    try {
      listener(cachedNavVisible);
    } catch {
      // Ignore subscriber errors.
    }
  });
};

export const setWebPlayerNavVisible = (value) => {
  cachedNavVisible = Boolean(value);
  hasFetched = true;
  notifySubscribers();
};

export const fetchWebPlayerNavVisible = async ({ force = false } = {}) => {
  if (process.env.NODE_ENV === 'test') {
    return cachedNavVisible;
  }
  if (!force && hasFetched) {
    return cachedNavVisible;
  }
  if (!force && inFlightRequest) {
    return inFlightRequest;
  }

  inFlightRequest = api.get('/auth/signup-config')
    .then((response) => {
      setWebPlayerNavVisible(response?.data?.webPlayer?.navVisible);
      return cachedNavVisible;
    })
    .catch(() => cachedNavVisible)
    .finally(() => {
      inFlightRequest = null;
    });
  return inFlightRequest;
};

export const useWebPlayerNavVisible = () => {
  const [navVisible, setNavVisible] = useState(cachedNavVisible);

  useEffect(() => {
    subscribers.add(setNavVisible);
    fetchWebPlayerNavVisible();
    return () => {
      subscribers.delete(setNavVisible);
    };
  }, []);

  return navVisible;
};
